import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Trans } from 'react-i18next';

import { makeGetCurrentUser } from '../selectors/users';
import { makeGetCurrentTeam } from '../selectors/teams';

import { BrowserNotificationsContext } from 'context/BrowserNotificationsContext';
import * as userStorageService from 'services/user-storage-service';

import Alert from './alert';

import IconInfo from 'icons/icon-info';

class BrowserNotificationRequest extends PureComponent {
    static contextType = BrowserNotificationsContext;

    state = {
        visible: false
    }

    handleEnableClick = () => {
        this.hide();

        this.context.requestNotificationsPermission();
    }

    handleSkipClick = () => {
        this.hide();
        userStorageService.set('browserNotificationSkipped', true);

    }

    hide() { 
        this.setState({
            visible: false
        });
    }

    init() {
        if (!this.context?.hasMessaging() || userStorageService.get('browserNotificationSkipped')) {
            return;
        }

        if (!['denied', 'granted'].includes(Notification.permission)) {
            this.setState({
                visible: true
            });
        }
    }

    componentDidMount() {
        if (this.props.canInit) {
            this.init();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.canInit && !prevProps.canInit) {
            this.init();
        }
    }

    render() {
        if (this.state.visible) {
            return (
                <Alert type="default" className="heavy" icon={<IconInfo />}>
                    <Trans
                        i18nKey="notifications:enablePushNotifications"
                        components={{
                            ButtonEnable: <button className="btn btn-in-alert btn-xsmall" style={{ margin: '0 10px' }} onClick={this.handleEnableClick} />,
                            ButtonSkip: <button className="btn btn-in-alert btn-xsmall" onClick={this.handleSkipClick} />
                        }}
                    />
                </Alert>
            )
        }

        return null;
    }
}

const makeMapStateToProps = () => {
    const getCurrentUser = makeGetCurrentUser();
    const getCurrentTeam = makeGetCurrentTeam();

    return ({ users, teams }) => {
        return {
            canInit: getCurrentUser(users) && getCurrentTeam(teams)
        }
    };
};

export default connect(makeMapStateToProps)(BrowserNotificationRequest);
